import { carLiability } from "../routes"

export const secondStep = `${carLiability}/second-step`
export const results = `${carLiability}/results`
export const form = `${carLiability}/form`
